import { render } from "./ViewForm.vue?vue&type=template&id=5ecce07a"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"

import "./ViewForm.vue?vue&type=style&index=0&id=5ecce07a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__